module.exports = __webpack_public_path__ + "img/article9.7e091b6c.jpg";